<div class="modal-content-frequency">
    <div class="flex-frequency">
        <div #flex1 class="flex-1"> 
            <div class="relative flex flex-col mb-2 sm:flex-row sm:items-center sm:justify-end">
                <span></span>
                <mat-slide-toggle style="margin-top: 0.7em; margin-right: 2em;" color="primary" [(ngModel)]="modeWeekDays" (click)="onChangeWeekDaysMode()">
                    Modo días de la semana
                </mat-slide-toggle>
                <button mat-icon-button (click)="openModalFrecuency()" color="primary">
                    <mat-icon svgIcon="heroicons_solid:map-pin"></mat-icon>
                </button>
                <button mat-raised-button color="primary" (click)="savePosition()" [disabled]="!showManyOrder">Guardar Ordenamiento Grupal</button>  
            </div>
            <div *ngIf="!modeWeekDays">
                <div *ngFor="let frequencyType of listFrecuencies;let isFirst = first"> 
                    <mat-expansion-panel class="custom-expansion-panel" (opened)="isFirst;toggleExpand(frequencyType);" (closed)="isFirst;closeExpand(frequencyType)" hideToggle>
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <div class="custom-indicator">
                                    <mat-icon>{{ frequencyType.expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
                                </div>
                                {{ getFrecuencyName(frequencyType.days)}}
                            </mat-panel-title>
                            <mat-panel-description>
                               {{frequencyType.businessPartners?.length}}
                            </mat-panel-description>
                        </mat-expansion-panel-header>
                        
                        <mat-expansion-panel-content>
                            <div class="relative flex flex-0 flex-col mt-2 mb-1 sm:flex-row sm:items-center sm:justify-between">
                                <div class="text-2xl font-extrabold tracking-tight">
                                    <mat-form-field class="fuse-mat-dense fuse-mat-rounded min-w-64" subscriptSizing="dynamic">
                                        <mat-icon class="icon-size-5" matPrefix svgIcon="heroicons_solid:magnifying-glass"></mat-icon>
                                        <input matInput placeholder="Buscar" autocomplete="off" (input)="onSearch($event.target.value, frequencyType)"/>
                                    </mat-form-field>
                                </div>
                                <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
                                    <button mat-icon-button (click)="openMoveBPModal(frequencyType.businessPartenerFrequencyList, 'copy', frequencyType._id)" matTooltip="Copiar" [disabled]="getSelectedCount(frequencyType) === 0">
                                        <mat-icon svgIcon="heroicons_outline:document-duplicate"></mat-icon>
                                    </button>
                                    <button mat-icon-button (click)="openMoveBPModal(frequencyType.businessPartenerFrequencyList, 'move', frequencyType._id)" matTooltip="Mover" [disabled]="getSelectedCount(frequencyType) === 0">
                                        <mat-icon svgIcon="heroicons_outline:arrow-right-on-rectangle"></mat-icon>
                                    </button>
                                    <button mat-icon-button (click)="openMoveBPModal(frequencyType.businessPartenerFrequencyList, 'delete', frequencyType._id)" matTooltip="Eliminar" [disabled]="getSelectedCount(frequencyType) === 0">
                                        <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                                    </button>
                                    <button mat-raised-button color="primary" (click)="savePosition(frequencyType._id)" [disabled]="showManyOrder || frequencyType.businessPartenerFrequencyList.length <= 0">
                                        Guardar Ord. Individual
                                    </button>
                                    <!--class="save-position-button" BUTTON FLOTANTE-->
                                </div>
                            </div>
                            <div class="container-button">
                                <table mat-table #mainTable [id]="'table-' + frequencyType._id" [(dataSource)]="frequencyType.businessPartenerFrequencyList" class="min-w-500 overflow-y-visible mat-elevation-z"
                                    cdkDropList #main="cdkDropList" [cdkDropListConnectedTo]="['client']" (cdkDropListDropped)="onListDrop($event, frequencyType)" 
                                    [cdkDropListData]="frequencyType.businessPartenerFrequencyList"  multiTemplateDataRows>
                                    <ng-container matColumnDef="det">
                                        <th mat-header-cell *matHeaderCellDef></th>
                                        <td mat-cell *matCellDef="let partner">
                                            <mat-checkbox [(ngModel)]="partner.selected"></mat-checkbox>
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="Nombre">
                                        <th mat-header-cell *matHeaderCellDef>Nombre</th>
                                        <td mat-cell *matCellDef="let partner">
                                            {{ partner.name || "Sin nombre" }}
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="Contacto">
                                        <th mat-header-cell *matHeaderCellDef>Contacto</th>
                                        <td mat-cell *matCellDef="let partner">
                                            {{ partner.principalContact?.fullName || "Sin contacto"}} <br>
                                            {{ partner.principalPhone?.phone || "Sin teléfono"}}
                                        </td>
                                    </ng-container>
                                    <tr mat-header-row *matHeaderRowDef="['det','Nombre','Contacto',]"></tr>
                                    <tr mat-row *matRowDef="let partner;columns: ['det','Nombre','Contacto']" cdkDrag [cdkDragData]="partner"></tr>
                                </table>
                            </div>
                            <div *ngIf="frequencyType.businessPartenerFrequencyList.length == 0" class="border-t p-8 text-center text-1xl tracking-tight sm:p-10">
                                No existen registros para visualizar.</div>
                        </mat-expansion-panel-content>
                    </mat-expansion-panel>
                </div>
            </div>
            
            <div *ngIf="modeWeekDays">
                <div *ngFor="let weekDay of listDayFrecuencies; let isFirst = first">
                    <mat-expansion-panel class="custom-expansion-panel" (opened)="isFirst;toggleExpandWD(weekDay);" (closed)="isFirst;closeExpand(weekDay)" hideToggle>
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <div class="custom-indicator">
                                    <mat-icon>{{ weekDay.expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
                                </div>
                                {{ weekDay.name }}
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                    

                        <mat-expansion-panel-content>
                            <div class="relative flex flex-0 flex-col mt-2 mb-1 sm:flex-row sm:items-center sm:justify-between">
                                <div class="text-2xl font-extrabold tracking-tight">
                                    <mat-form-field class="fuse-mat-dense fuse-mat-rounded min-w-64" subscriptSizing="dynamic">
                                        <mat-icon class="icon-size-5" matPrefix svgIcon="heroicons_solid:magnifying-glass"></mat-icon>
                                        <input matInput placeholder="Buscar" autocomplete="off" (input)="onSearch($event.target.value, weekDay)"/>
                                    </mat-form-field>
                                </div>
                                <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
                                    <button mat-raised-button color="primary" (click)="saveWDPosition(weekDay)" >
                                        Guardar Ord. Individual
                                    </button>
                                    <!--class="save-position-button" BUTTON FLOTANTE-->
                                </div>
                            </div>
                            <div class="container-button">
                                <table mat-table #mainTable [id]="'table-' + weekDay._id" [(dataSource)]="weekDay.businessPartenerFrequencyList" class="min-w-500 overflow-y-visible mat-elevation-z"
                                    cdkDropList #main="cdkDropList" [cdkDropListConnectedTo]="['client']" (cdkDropListDropped)="onListDrop($event, weekDay)" 
                                    [cdkDropListData]="weekDay.businessPartenerFrequencyList"  multiTemplateDataRows>
                                    <ng-container matColumnDef="Nombre">
                                        <th mat-header-cell *matHeaderCellDef>Nombre</th>
                                        <td mat-cell *matCellDef="let partner">
                                            <b *ngIf="partner?.externalKeys?.code">{{ partner?.externalKeys?.code ? partner.externalKeys.code : ''}}<br></b>
                                            {{ partner.name || "Sin nombre" }}
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="Contacto">
                                        <th mat-header-cell *matHeaderCellDef>Contacto</th>
                                        <td mat-cell *matCellDef="let partner">
                                            {{ partner.principalContact?.fullName || "Sin contacto"}} <br>
                                            {{ partner.principalPhone?.phone || "Sin teléfono"}}
                                        </td>
                                    </ng-container>
                                    <tr mat-header-row *matHeaderRowDef="['Nombre','Contacto',]"></tr>
                                    <tr mat-row *matRowDef="let partner;columns: ['Nombre','Contacto']" cdkDrag [cdkDragData]="partner"></tr>
                                </table>
                                <div *ngIf="weekDay.businessPartenerFrequencyList.length == 0" class="border-t p-8 text-center text-1xl tracking-tight sm:p-10">
                                    No existen registros para visualizar.</div>
                            </div>
                        </mat-expansion-panel-content>
                    </mat-expansion-panel>
                </div>
            </div>
            
        </div>
    </div>

    <!-- Modal Mover BP de Frecuencia-->
    <ng-template #moveBPFromFrecuencyModal>
        <h2 mat-dialog-title class="text-lg font-bold mb-1 ml-4 mt-4">Frecuencias</h2>
        <mat-dialog-content class="modal-content">
            <div class="flex justify-end mb-2">
                <mat-form-field class="w-full mt-2" appearance="fill" floatLabel="never">
                    <mat-select [(ngModel)]="frecuencyIdForActionSelected" aria-label="Accion" [ngModelOptions]="{standalone: true}">
                        <mat-option *ngFor="let ft of listFrecuencies" [value]="ft._id">
                            {{getFrecuencyName(ft.days)}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions class="modal-actions flex justify-end">
            <button mat-button mat-dialog-close class="align-left" (click)="dialogRefMoveBP.close()">Cancelar</button>
            <button
                mat-raised-button
                color="primary"
                (click)="moveBP()"
                class="justify-end"
            >
                {{ 'Guardar' }}
            </button>
          </mat-dialog-actions>
    </ng-template>
</div>